import BaseModel from "./Abstracts/BaseModel";

export default class Question extends BaseModel{
    constructor(data) {
        super()
        this.$dirty = false
        this.id = null
        this.position = 99
        this.title = ''
        this.correctDisplayText = ''
        this.incorrectDisplayText = ''
        this.questionTypeData = {}
        this.urls = {
            edit: '',
            delete: ''
        }
        this.tokens = {
            edit: '',
            delete: ''
        }

        this.meta = {
            correct: false,
            display: false,
            continueToNextQuestion: false,
        }

        this._skipKeys = ['$dirty', 'id', 'questionTypeData', 'urls', 'tokens', '_skipKeys', 'meta'];

        this.setData(data);
        this.setInitialized()
    }

    getFormData() {
        const formData = super.getFormData()
        formData.append('questionTypeData', JSON.stringify(this.questionTypeData))
        formData.append('questionType', this.handle)

        return formData;
    }
}
